export enum PassengerTypeCodesEnum {
    Adult = 'ADT',
    Child = 'CHD',
    Infant = 'INF',
    InfantOld = 'INL',
    AdultWithChild = 'ADTC',
    AdultWithReducedMobility = 'WADT',
    /**
     * Adult that is at the same time a companion for a child and for another adult with reduced mobility
     */
    AdultWithChildAndCompanionForReducedMobility = 'ADCW',

    Student = 'STU',
    StudentWithChild = 'STUC',
    AdultWithMedicalReason = 'MED',
    AdultWithMedicalReasonAndChild = 'MEDC',
    AdultRetired = 'SRC',
    AdultRetiredWithChild = 'SRCC',

    AdultClubMember = 'ADTA',
    ChildClubMember = 'CHDA',
    Dog = 'DOG',

}

export const ADULT_TYPE_CODES = [
    PassengerTypeCodesEnum.Adult,
    PassengerTypeCodesEnum.AdultWithReducedMobility,
    PassengerTypeCodesEnum.AdultWithChildAndCompanionForReducedMobility,
    PassengerTypeCodesEnum.Student,
    PassengerTypeCodesEnum.StudentWithChild,
    PassengerTypeCodesEnum.AdultWithMedicalReason,
    PassengerTypeCodesEnum.AdultWithMedicalReasonAndChild,
    PassengerTypeCodesEnum.AdultRetired,
    PassengerTypeCodesEnum.AdultRetiredWithChild,
    PassengerTypeCodesEnum.AdultWithChild,
    PassengerTypeCodesEnum.AdultClubMember
];

export const ANIMAL_TYPE_CODES = [
    PassengerTypeCodesEnum.Dog
];

export const COMPANION_TYPES_FOR_REDUCED_MOBILITY = [
    PassengerTypeCodesEnum.Adult,
    PassengerTypeCodesEnum.AdultWithChild,
    PassengerTypeCodesEnum.AdultWithReducedMobility,
    PassengerTypeCodesEnum.AdultWithChildAndCompanionForReducedMobility
];

export const STUDENT_TYPE_CODES = [PassengerTypeCodesEnum.Student, PassengerTypeCodesEnum.StudentWithChild];

export const ADULTS_WITH_MEDICAL_REASON = [PassengerTypeCodesEnum.AdultWithMedicalReason, PassengerTypeCodesEnum.AdultWithMedicalReasonAndChild];

export const ADULTS_RETIRED = [PassengerTypeCodesEnum.AdultRetired, PassengerTypeCodesEnum.AdultRetiredWithChild];

export const CHILD_TYPE_CODES = [PassengerTypeCodesEnum.Child, PassengerTypeCodesEnum.ChildClubMember];

export const INFANT_TYPE_CODES = [PassengerTypeCodesEnum.Infant, PassengerTypeCodesEnum.InfantOld];

export function countInfants(passengerTypesCount: Record<string, number>): number {
    return INFANT_TYPE_CODES.sum(code => passengerTypesCount[code] ?? 0);
}

export const WITH_CHILD_TYPE_CODES_MAPPINGS: Record<PassengerTypeCodesEnum, PassengerTypeCodesEnum | undefined> = {
    [PassengerTypeCodesEnum.Student]: PassengerTypeCodesEnum.StudentWithChild,
    [PassengerTypeCodesEnum.StudentWithChild]: PassengerTypeCodesEnum.StudentWithChild,
    [PassengerTypeCodesEnum.AdultWithMedicalReason]: PassengerTypeCodesEnum.AdultWithMedicalReasonAndChild,
    [PassengerTypeCodesEnum.AdultWithMedicalReasonAndChild]: PassengerTypeCodesEnum.AdultWithMedicalReasonAndChild,
    [PassengerTypeCodesEnum.AdultRetired]: PassengerTypeCodesEnum.AdultRetiredWithChild,
    [PassengerTypeCodesEnum.AdultRetiredWithChild]: PassengerTypeCodesEnum.AdultRetiredWithChild,
    [PassengerTypeCodesEnum.Adult]: PassengerTypeCodesEnum.AdultWithChild,
    [PassengerTypeCodesEnum.AdultWithChild]: PassengerTypeCodesEnum.AdultWithChild,
    [PassengerTypeCodesEnum.AdultWithReducedMobility]: PassengerTypeCodesEnum.AdultWithChildAndCompanionForReducedMobility,
    [PassengerTypeCodesEnum.AdultWithChildAndCompanionForReducedMobility]: PassengerTypeCodesEnum.AdultWithChildAndCompanionForReducedMobility,
    [PassengerTypeCodesEnum.Child]: undefined,
    [PassengerTypeCodesEnum.Infant]: undefined,
    [PassengerTypeCodesEnum.InfantOld]: undefined,
    [PassengerTypeCodesEnum.AdultClubMember]: undefined,
    [PassengerTypeCodesEnum.ChildClubMember]: undefined,
    [PassengerTypeCodesEnum.Dog]: undefined,
}

export function getRelatedPassengerTypes(passengerType: PassengerTypeCodesEnum): PassengerTypeCodesEnum[] {
    const withChildPassengerType = WITH_CHILD_TYPE_CODES_MAPPINGS[passengerType];
    if(withChildPassengerType) {
        return [withChildPassengerType];
    }
    return [];

}